var _circle, _path, _rect, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7786 28.0476C31.7096 28.0476 24.3577 35.3995 24.3577 44.4686V54.2482C24.3577 54.4774 24.3694 54.7038 24.3923 54.9269C24.3574 56.8042 24.3574 58.9461 24.3574 61.421V69.6787C24.3574 78.8752 24.3574 83.4735 26.1472 86.9862C27.7215 90.076 30.2336 92.5881 33.3234 94.1624C36.836 95.9522 41.4343 95.9522 50.6309 95.9522H73.3694C82.566 95.9522 87.1643 95.9522 90.6769 94.1624C93.7667 92.5881 96.2788 90.076 97.8531 86.9862C99.6429 83.4735 99.6429 78.8752 99.6429 69.6786V61.4209C99.6429 52.2244 99.6429 47.6261 97.8531 44.1134C96.2788 41.0236 93.7667 38.5116 90.6769 36.9372C87.1643 35.1474 82.566 35.1474 73.3694 35.1474H73.114C65.5969 35.1474 58.4801 28.0476 50.9629 28.0476H40.7786Z",
    fill: "url(#paint0_linear_7212_7867)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.2426,
    y: 40.1733,
    width: 67.5084,
    height: 36.8626,
    rx: 6.57143,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7212_7867)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.3574,
    y: 44.4929,
    width: 75.2855,
    height: 50.974,
    rx: 16.4209,
    fill: "black",
    fillOpacity: 0.26
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5359 47.7781C84.7917 47.7817 86.6215 47.8023 88.156 47.9109C90.1997 48.0555 91.6876 48.355 92.9314 48.9578C95.1557 50.0358 96.9409 51.731 98.071 53.8406C98.7016 55.0178 99.0147 56.4235 99.1667 58.3611C99.281 59.8171 99.3035 61.5544 99.3074 63.699V79.7019C99.3035 81.8467 99.281 83.5837 99.1667 85.0398C99.0147 86.9778 98.7017 88.384 98.071 89.5613C96.9409 91.6709 95.1558 93.3661 92.9314 94.4441C91.6876 95.0468 90.1997 95.3454 88.156 95.49C86.11 95.6347 83.5385 95.6238 80.1326 95.6238H43.8611C40.4549 95.6238 37.8827 95.6348 35.8367 95.49C33.7931 95.3454 32.3059 95.0468 31.0623 94.4441C28.8379 93.3661 27.0528 91.6709 25.9226 89.5613C25.2919 88.384 24.9789 86.9778 24.8269 85.0398C24.7127 83.5837 24.6902 81.8467 24.6863 79.7019V63.699C24.6902 61.5544 24.7127 59.8171 24.8269 58.3611C24.9789 56.4234 25.292 55.0178 25.9226 53.8406C27.0527 51.731 28.8379 50.0358 31.0623 48.9578C32.3059 48.355 33.7931 48.0555 35.8367 47.9109C37.3713 47.8023 39.2017 47.7817 41.4578 47.7781H82.5359Z",
    fill: "url(#paint1_linear_7212_7867)",
    stroke: "url(#paint2_linear_7212_7867)",
    strokeWidth: 0.656838,
    strokeMiterlimit: 4.13936
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7212_7867",
    x: 17.1354,
    y: 37.2709,
    width: 89.7295,
    height: 65.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.611,
    result: "effect1_foregroundBlur_7212_7867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7212_7867",
    x1: 60.246,
    y1: 96.6319,
    x2: 64.9139,
    y2: 21.9092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328006,
    stopColor: "#74D1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BE5E7",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7212_7867",
    x1: 60.2428,
    y1: 96.4379,
    x2: 61.6648,
    y2: 48.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7212_7867",
    x1: 60.2428,
    y1: 96.4379,
    x2: 61.6648,
    y2: 48.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocuments);
export default __webpack_public_path__ + "static/media/DownloadDocuments.4b4f80a310acf81bfa5ce8a281fd69a5.svg";
export { ForwardRef as ReactComponent };